import type { Location } from '@/common/api/types/location';
import type { FilterOption } from '@/common/components/filters/types';

export const UNASSIGNED_FILTER_VALUE = '0';

export const EMPTY_LOCATIONS: Location[] = [];

export type LocationFilterOptionsContext = {
  includeArchived: boolean;
  selectedCountryCodes: string[];
};

export const EMPTY_LOCATION_FILTER_CONTEXT: LocationFilterOptionsContext = {
  includeArchived: false,
  selectedCountryCodes: [],
};

export const getFilterOptions = ({ name, id }: { name: string; id: number }): FilterOption => ({
  label: name,
  value: id,
});

export const sortByLabel = (a: FilterOption, b: FilterOption) => a.label.localeCompare(b.label);

export const NoValueFilterLabel = ({ label }: { label: string }) => (
  <span className="italic">{label}</span>
);

export const FlaggedFilterLabel = ({ flag, label }: { flag: string; label: string }) => (
  <span className="flex items-center gap-2">
    <span aria-hidden>{flag}</span>
    <span>{label}</span>
  </span>
);

export const withUnassignedOption = (options: FilterOption[], label: string): FilterOption[] => [
  { label, value: UNASSIGNED_FILTER_VALUE, component: <NoValueFilterLabel label={label} /> },
  ...options,
];
